import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { render } from "react-dom";
import { Provider } from "react-redux";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// Redux Store
import { store } from "./store/store";
// Component
import { App } from "../src/App";

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("app")
);
